import Overlay from './overlay';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';
import pick from 'lodash-es/pick';
import defaultsDeep from 'lodash-es/defaultsDeep';
// import lookAndFeel from '../lookAndFeel';

export default class ContextMenu extends Overlay {

  onReady(){
    _.each(this.childrenControls,ctrl=>{
      ctrl.addTrigger('click',()=>{
        if(ctrl.options.closeMenu){
          setTimeout(()=>{
            this.hide();
          },0);
        }        
      });
    });
    console.log(`${this.nicePath} is ${this.visible?'visible':'hidden'} (onReady)`);
    this.addTrigger('visible',() => {
      if(this.visible){
        console.log(`${this.nicePath} is visible`);

        if(this.parentControl){
          this.anchor = this.parentControl.anchor;
        }

        _.each(this.childrenControls, ctrl => ctrl.anchor=this.anchor);
      }else{
        console.log(`${this.nicePath} is hidden`);
      }
    })

    if(!this.parentControl){
      if(this._controlOptions.serieIndex!==undefined){
        this.instance.chart.on('contextmenu', this._onContextMenu);
      }else{
        this.instance.args.element.addEventListener('contextmenu', this._onContextMenu);        
      }
    }

    super.onReady();
  }

  destroy(){
    super.destroy();
    this.instance.args.element.removeEventListener('contextmenu', this._onContextMenu);
  }

  renderElement() {
    console.log(`${this.nicePath} is ${this.visible?'visible':'hidden'} (renderElement)`);
    // this._controlOptions.visible = false;
    // console.log('renderContextMenu', control, options, instance, path);
    this._controlOptions = defaultsDeep(this._controlOptions, {      
      visible: false,
      style: {        
        normal: {
          bottom: 'auto',
          right: 'auto',
          width: '128px',
          height: 'auto',
          zIndex: 100500,
          backgroundColor: '${schemeSysBackground}',          
        },
      },
    });

    
    const me = this;
    _.each(this._controlOptions.controls,(ctrl => {
      if(ctrl.type=='button'){
        _.defaultsDeep(ctrl,{
            closeMenu:true,
            label: {
              text: 'Menu Item...',
              align:'left',
              style:{
                normal:{
                  margin:'0px 0px 0px 24px'
                }
              }
            },
            icon:{
              position:'left',
              size:'16px',
              url: 'themes/css/img/icon-placeholder.png',
            },
            style: {
              normal: {
                top:'auto',
                left:'auto',
                height: '32px',                
                width: '100%',
                position: 'relative',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                borderRadius: '0px',
                borderColor: 'transparent',
                display:'block'
              },
              hover: {
                boxShadow:'none',
                backgroundColor: '#ffffff2a'
              }
            }
          }
        );        
      }

    }));

    const el = super.renderElement();

    if(el){
      var bodyEl = el.getElementsByClassName('body')[0];
      bodyEl.style.top = 'auto';
      bodyEl.style.right = 'auto';
      bodyEl.style.bottom = 'auto';
      bodyEl.style.left = 'auto';      
      bodyEl.style.position = 'static';
      if(!this.visible){
        bodyEl.style.opacity = 0;
      }      

      el.style.transitionProperty='';
      el.classList.add('io-controls');
    }

    return el;
  }

  
}
